import { Schemas } from '~/clients/api-client'

export type ToggleFilteredBySelectionFn<T extends string = string> = (args: { filters: { value: string; label: string }[]; type: T }) => void

const createFilterOption = (value: string) => ({ value, label: value })

/**
 * Applies a single filter entry from the profile to the current filter selection.
 *
 * @param type the filter type
 * @param filterValues  the filter values to apply
 * @param toggleFilteredBySelection function to toggle the filter selection
 * @returns
 */
const applyFilterEntry = <T extends string>(type: T, filterValues: unknown, toggleFilteredBySelection: ToggleFilteredBySelectionFn<T>) => {
    if (!Array.isArray(filterValues)) {
        return
    }

    const filters = (filterValues as string[]).map(createFilterOption)
    toggleFilteredBySelection({ type, filters })
}

/**
 * Creates a function that applies a filter profile to the current filter selection.
 *
 * @param toggleFilteredBySelection the funciton to toggle the filter selection
 * @returns a function that applies the filter profile to the current filter selection
 */
export const createApplyFilterProfile =
    <T extends string>(toggleFilteredBySelection: ToggleFilteredBySelectionFn<T>) =>
    (profile: Schemas['ViewOptionProfileOut'] | undefined) => {
        if (!profile?.filter_profile) {
            return
        }

        Object.entries(profile.filter_profile).forEach(([type, filterValues]) => {
            applyFilterEntry(type as T, filterValues, toggleFilteredBySelection)
        })
    }
